import React from 'react'
import { Link } from 'react-router-dom'

function Catering() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>
        <div className="auto-container">
          <div className="inner">
            <h1>Catering</h1>
            <div className="sub_text">
              <p>
                Home - <a href="contact" className="primary-color">Catering</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box">
            <div className="subtitle"><span>Tickling Tummy</span></div>
            <h2>
              <span className="theme_color">Event Catering</span> – Homemade Veg Meals for Parties & Meetings in Coimbatore
            </h2>
          </div>
          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                <span className="theme_color">Planning a special event in Coimbatore?</span> Whether it’s a
                birthday party, housewarming, anniversary celebration, or a corporate meeting,
                Tickling Tummy is ready to serve you with a wide range of pure-veg, homemade catering
                options. Expect thoughtfully cooked meals, snacks, and savories packed with the warmth and
                comfort of home—even for large gatherings.
              </p>
              <br />
              <p>
                Our home kitchen excels at delivering homemade quality at scale. From small family gatherings
                to big celebratory events, we manage everything—from customized menus to timely delivery—so
                you can focus on celebrating.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Section */}
      <section className="menu-one alternate section-kt">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="image-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="vertical-title">Catering</div>
                <div className="image">
                  <img src="assets/images/catering-services-offered.jpg" alt="home chefs Coimbatore" />
                </div>
              </div>
            </div>

            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="title-box" style={{ marginTop: "40px" }}>
                  <h3>What We Can Provide</h3>
                </div>

                <div className="table-responsive">
                  <table className="event-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ padding: "12px", textAlign: "left", border: "1px solid #ddd", color: "#560206", backgroundColor: "#e8b067" }}>Event Type</th>
                        <th style={{ padding: "12px", textAlign: "left", border: "1px solid #ddd", color: "#560206", backgroundColor: "#e8b067" }}>Sample Menu Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-label="Event Type" style={{ padding: "12px", border: "1px solid #ddd" }}>Birthday & House Parties</td>
                        <td data-label="Sample Menu Options" style={{ padding: "12px", border: "1px solid #ddd" }}>Veg starters, chaat counters, mini-meals, cookies, cakes</td>
                      </tr>
                      <tr>
                        <td data-label="Event Type" style={{ padding: "12px", border: "1px solid #ddd" }}>Anniversaries & Special Occasions</td>
                        <td data-label="Sample Menu Options" style={{ padding: "12px", border: "1px solid #ddd" }}>Themed spreads, South/North Indian fare, desserts</td>
                      </tr>
                      <tr>
                        <td data-label="Event Type" style={{ padding: "12px", border: "1px solid #ddd" }}>Corporate Meetings & Workshops</td>
                        <td data-label="Sample Menu Options" style={{ padding: "12px", border: "1px solid #ddd" }}>Lunch/dinner packages, snack boxes, tea-tiffin combos</td>
                      </tr>
                      <tr>
                        <td data-label="Event Type" style={{ padding: "12px", border: "1px solid #ddd" }}>Outdoor & Backyard Events</td>
                        <td data-label="Sample Menu Options" style={{ padding: "12px", border: "1px solid #ddd" }}>Boxed meals, live counters (dosa, chaat), snack assortments</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Catering Details Section */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix">
            {/* Image Column */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInLeft">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/catering-service-details-coimbatore.jpg)" }}
                ></div>
                <div className="image">
                  <img src="assets/images/catering-service-details-coimbatore.jpg" alt="local home kitchen Coimbatore" />
                </div>
              </div>
            </div>

            {/* Content Column */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInRight">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img src="assets/images/catering-service-icon.jpg" alt="homemade food vendors Coimbatore" />
                  </div>

                  <div className="title-box centered">
                    <div className="subtitle"><span>Why Choose Our Catering Service</span></div>
                    <div className="text">
                      <ul>
                        <li>◆ Homemade & hygienic – fresh pure-veg food cooked daily</li>
                        <li>◆ Fully customizable menus – low oil, less salt, sugar-free, or Jain-friendly options</li>
                        <li>◆ Scalable for any team size – ideal for intimate get-togethers or big events</li>
                        <li>◆ Flexible offerings – snack boxes, full-course meals, tea-time treats, or buffet</li>
                      </ul>
                    </div>
                  </div>

                  <div className="title-box centered">
                    <div className="subtitle"><span>How It Works</span></div>
                    <div className="text">
                      <ul>
                        <li>◆ Share your event details – date, venue, headcount</li>
                        <li>◆ Choose menu style – plated meals, buffet, snack boxes, live counters</li>
                        <li>◆ Customize cooking preferences – like your food at home</li>
                        <li>◆ Enjoy the feast – delicious, homemade meals without you lifting a spoon</li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FAQ Schema for Catering */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Do you provide catering for small house parties in Coimbatore?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we specialize in small to medium-sized event catering (birthdays, anniversaries, housewarmings) with customized homemade vegetarian menus."
              }
            },
            {
              "@type": "Question",
              "name": "Can I choose my own menu items for catering?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We offer fully customizable menus, including traditional South Indian, North Indian, and snack-based options tailored to your event's needs."
              }
            },
            {
              "@type": "Question",
              "name": "Do you handle food delivery and setup for events?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide timely delivery to your venue in Coimbatore. For smaller events, we offer easy-to-serve packages, and for larger ones, we can discuss setup options."
              }
            }
          ]
        })}
      </script>
    </>
  );
}

export default Catering
